<template>
    <div>



    </div>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
                required: true
            },
            retailers: {
                Type: Array,
                required: true
            }
        },
        data() {
            return {
                priceProduct: null,
                showModal: false,
                prices: null,
                loading: false
            }
        },
        methods: {
            openModal() {
                this.getPrices();
                this.showModal = true;
            },

        }
    }
</script>